<div class="result-filters">
  @for (chip of chips(); track chip.id) {
    <button
      type="button"
      class="filter-chip"
      [class.active]="chip.selected"
      (click)="select(chip.id)"
    >
      <span>{{ chip.label | translate }}</span>
    </button>
  }
</div>
